import React, { useState } from 'react';
import { Menu, User, LogOut, Settings } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';

const Header = ({ onMenuClick }) => {
  const { user, logout, isSystemAdmin } = useAuth();
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/admin/settings')) return 'Ayarlar';
    if (path.includes('/admin/reports')) return 'Sistem Raporları';
    if (path.includes('/admin/users')) return 'Kullanıcı Yönetimi';
    if (path.includes('/admin/locations')) return 'Lokasyon Yönetimi';
    if (path.includes('/admin')) return 'Sistem Yönetimi';
    if (path.includes('/owner/settings')) return 'Ayarlar';
    if (path.includes('/owner/reports')) return 'Raporlar';
    if (path.includes('/owner/users')) return 'Kullanıcı Yönetimi';
    if (path.includes('/owner')) return 'İşletme Paneli';
    if (path.includes('/dashboard')) return 'Ana Sayfa';
    if (path.includes('/vehicles/new')) return 'Yeni Araç Girişi';
    if (path.includes('/vehicles')) return 'Araçlar';
    if (path.includes('/reports')) return 'Raporlar';
    if (path.includes('/settings')) return 'Ayarlar';
    return 'İşletme Paneli';
  };

  const handleLogout = async () => {
    await logout();
    setUserMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="flex items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        {/* Left side */}
        <div className="flex items-center space-x-4">
          {/* Mobile menu button */}
          <button
            type="button"
            className="lg:hidden rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500"
            onClick={onMenuClick}
          >
            <Menu className="h-6 w-6" />
          </button>

          {/* Page title */}
          <h1 className="text-2xl font-semibold text-gray-900">
            {getPageTitle()}
          </h1>
        </div>

        {/* Right side */}
        <div className="flex items-center space-x-4">

          {/* User menu */}
          <div className="relative">
            <button
              type="button"
              className="flex items-center space-x-3 rounded-full p-1 text-sm hover:bg-gray-100"
              onClick={() => setUserMenuOpen(!userMenuOpen)}
            >
              <div className="flex items-center space-x-2">
                <div className="h-8 w-8 rounded-full bg-[#7a2c2c] flex items-center justify-center">
                  <User className="h-4 w-4 text-white" />
                </div>
                <div className="hidden md:block text-left">
                  <p className="font-medium text-gray-900">{user?.full_name || user?.username}</p>
                </div>
              </div>
            </button>

            {/* User dropdown menu */}
            {userMenuOpen && (
              <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                <div className="py-1">
                  {/* User Info */}
                  <div className="px-4 py-3 border-b border-gray-100">
                    <p className="text-sm font-medium text-gray-900">{user?.full_name || user?.username}</p>
                    <p className="text-xs text-gray-500 mt-0.5">
                      {isSystemAdmin() ? 'Sistem Yöneticisi' : user?.isOwner ? 'İşletme Sahibi' : 'Personel'}
                    </p>
                  </div>

                  {/* Menu Items */}
                  <div className="py-1">
                    <button
                      className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                      onClick={() => {
                        setUserMenuOpen(false);
                        if (isSystemAdmin()) {
                          navigate('/admin/settings');
                        } else if (user?.isOwner) {
                          navigate('/owner/settings');
                        } else {
                          navigate('/settings');
                        }
                      }}
                    >
                      <Settings className="mr-2 h-4 w-4 text-gray-400" />
                      <span>Ayarlar</span>
                    </button>

                    <button
                      className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                      onClick={handleLogout}
                    >
                      <LogOut className="mr-2 h-4 w-4 text-gray-400" />
                      <span>Çıkış Yap</span>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Close user menu when clicking outside */}
      {userMenuOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setUserMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;